<figure>
    <button @slideInUp class="closeBtn" mat-icon-button mat-dialog-close>
        <mat-icon [icIcon]="close"></mat-icon>
    </button>
    <img @fadeIn [src]="this.image" alt="">
</figure>